<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            <button style="margin-right: 25px; font-size: 15px" onclick="history.back()" class="btn btn-primary btn-lg">Voltar</button>
            Documentos

            <a :href="'/admin/leilao/' + leilao.id + '/lotes'" type="button" class="btn btn-info" style="margin-left: 15px">
              <i class="fa-solid fa-plus" style="margin-right: 5px"></i>
              Listar lotes
            </a>
          </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/documentos">Documentos</a></li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>

  <div>
    <!--
        <div class="card card-primary">
            <div class="card-header">
                <h3 class="card-title">
                    Adicionar arquivo leilão
                </h3>
            </div>
            <div class="card-body">
                <br />
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="custom-file">
                                    <input class="form-control" type="file" @change="onChangeLeilao" multiple="multiple"
                                        style="height: 80px; margin-bottom: 25px;" />
                                </div>
                            </div>
                        </div>
                        <button @click="uploadLeilao()" class="btn btn-info">
                            Enviar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        -->
    <div class="card card-primary">
      <div class="card-header">
        <h3 class="card-title">Adicionar arquivo lote</h3>
      </div>
      <div class="card-body">
        <br />
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <div class="input-group">
                <div class="custom-file">
                  <input class="form-control" type="file" @change="onChangeLote" multiple="multiple" style="height: 80px; margin-bottom: 25px" />
                </div>
              </div>
            </div>
            <button @click="sendFileS3()" class="btn btn-info">Enviar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABELA DE documentos -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Documentos</h3>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th style="text-align: center">Seq</th>
                <th style="text-align: center">Imagem</th>
                <th>Ordenação</th>
                <th>Nome</th>
                <th>Extensão</th>
                <th style="text-align: center">Data criação</th>
                <th style="text-align: center">Vinculado ao leilão</th>
                <th style="text-align: center">Edital</th>
                <th style="text-align: center">Vinculado aos lotes</th>
                <th style="text-align: center">Vincular</th>
                <th style="text-align: center">Deletar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(documento, index) in documentos" :key="documento">
                <td data-label="Seq">{{ index + 1 }}</td>
                <td @click.prevent="downloadWithAxios(documento)" data-label="Imagem" v-if="documento.ext != 'pdf'">
                  <img width="90px" height="50px" :src="getImagePath(documento)" />
                </td>
                <td @click.prevent="downloadWithAxios(documento)" data-label="Imagem" v-else>
                  <img width="50px" height="50px" src="https://rochaleiloes.com.br/dist/img/pdf.png" />
                </td>
                <td data-label="Ordem">
                  <span class="right badge badge-secondary" v-if="!documento.edit_ordem" style="font-size: 13px">
                    {{ documento.ordem }}
                    <i class="fas fa-pen" @click="documento.edit_ordem = true" style="cursor: pointer"></i>
                  </span>

                  <form v-on:submit.prevent="editarOrdem(documento)">
                    <div class="input-group" v-if="documento.edit_ordem">
                      <div class="input-group input-group-sm">
                        <input
                          style="width: 50%; max-width: 70px; font-size: 15px; max-height: 26px"
                          type="text"
                          class="form-control"
                          v-model="documento.ordem"
                          @click="documento.edit_ordem = true"
                        />

                        <span class="input-group-append">
                          <button style="max-height: 26px" @click="editarOrdem(documento)" type="button" class="btn btn-info btn-flat">
                            <i class="fa fa-check"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </form>
                </td>
                <td data-label="Nome">
                  <span class="right badge badge-secondary" v-if="!documento.edit" style="font-size: 15px">
                    {{ documento.nome }}
                    <i class="fas fa-pen" @click="documento.edit = true" style="cursor: pointer"></i>
                  </span>

                  <div class="input-group" v-if="documento.edit">
                    <div class="input-group input-group-sm">
                      <input
                        style="width: 70%; max-width: 120px; font-size: 15px; max-height: 30px"
                        type="text"
                        class="form-control"
                        v-model="documento.nome"
                        @click="documento.edit = true"
                      />

                      <span class="input-group-append">
                        <button style="max-height: 30px" @click="editarNome(documento)" type="button" class="btn btn-info btn-flat">
                          <i class="fa fa-check"></i>
                        </button>
                      </span>
                    </div>
                  </div>

                  <!--
                  <div class="input-group">
                    <div class="input-group input-group-sm" style="width: 100%">
                      <div class="input-group-append">
                        <button class="btn" type="submit" style="margin-right: 5px" @click="documento.edit = true" v-if="!documento.edit">
                          <i class="fas fa-pen"></i>
                        </button>
                        <button class="btn" type="submit" style="margin-right: 5px" @click="editarNome(documento)" v-if="documento.edit">
                          <i class="fas fa-check" style="color: green"></i>
                        </button>
                      </div>

                      <form v-on:submit.prevent="editarNome(documento)">
                        <input
                          style="text-transform: uppercase"
                          type="text"
                          class="form-control"
                          :disabled="!documento.edit"
                          v-model="documento.nome"
                          @click="documento.edit = true"
                        />
                      </form>
                    </div>
                  </div>
                  -->
                </td>

                <td data-label="Extensão">{{ documento.ext }}</td>
                <td data-label="Data criação">{{ formatDate(documento.created_at) }}</td>
                <td data-label="Vinculado ao leilão" style="text-align: center">
                  <!--
                                    <span class="right badge " v-if="isVinculado(documento) == 'Sim'"
                                        style="background-color: rgb(5, 168, 5); color: white; cursor: pointer;"
                                        @click="desvincularAoLeilao(documento)">
                                        {{ isVinculado(documento) }}
                                        <i class="fas fa-trash" style="margin-left: 3px;"></i>
                                    </span>
                                    <span class="right badge " v-else
                                        style="background-color: rgb(4, 83, 185); color: white; cursor: pointer;"
                                        @click="vincularAoLeilao(documento)">
                                        {{ isVinculado(documento) }}
                                        <i class="fas fa-check" style="margin-left: 3px;"></i>
                                    </span>
                              
                  <select class="form-control" id="user_type" :value="isVinculado(documento)" @change="atualizarVinculoLeilao(documento)">
                    <option value="Sim">Sim</option>
                    <option value="Não">Não</option>
                  </select>
                    -->
                  <div class="row">
                    <div class="col-md-6">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="Sim"
                        v-model="documento.vinculado_leilao"
                        @change="atualizarVinculoLeilao(documento)"
                      />
                      <label class="form-check-label">Sim</label>
                    </div>
                    <div class="col-md-6">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="Não"
                        v-model="documento.vinculado_leilao"
                        @change="atualizarVinculoLeilao(documento)"
                      />
                      <label class="form-check-label">Não</label>
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    type="checkbox"
                    id="agreeTerms"
                    name="terms"
                    value="agree"
                    v-model="documento.is_edital"
                    @change="atualizarDocumentoEdital(documento)"
                  />
                </td>

                <td data-label="Vinculado" style="text-align: center">
                  <a
                    v-for="(lote, index) in getLotesDoLeilao(documento.lotes)"
                    :key="lotes"
                    type="button"
                    class="btn btn-info btn-sm"
                    @click="desvincularAoLote(documento, lote)"
                    style="margin-right: 5px"
                  >
                    Lote {{ lote.lote_numero }}
                    <i class="fas fa-trash"></i>
                  </a>
                </td>

                <td style="text-align: center">
                  <div class="input-group mb-3">
                    <select
                      v-if="documento.lotes"
                      class="custom-select rounded-0"
                      id="endereco_cidade"
                      v-model="documento.lote_selecionado"
                      style="text-transform: uppercase"
                    >
                      <option v-for="(lote, index) in getArrayLotes(documento.lotes)" :key="lote" :value="lote">{{ lote.lote_numero }}</option>
                    </select>
                    <select v-else class="custom-select rounded-0" id="endereco_cidade" v-model="lote_selecionado" style="text-transform: uppercase">
                      <option v-for="(lote, index) in lotes" :key="lote" :value="lote">{{ lote.lote_numero }}</option>
                    </select>
                    <div class="input-group-append">
                      <button type="submit" class="btn btn-primary" @click="vincularAoLote(documento)">Vincular</button>
                    </div>
                  </div>

                  <!--
                  <a
                    v-if="documento.lotes"
                    :key="lotes"
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="vincularAoLote(documento, lote)"
                    style="margin-right: 5px"
                  >
                    Lote {{ lote }}
                    <i class="fas fa-link"></i>
                  </a>
                  <a
                    v-else
                    v-for="(lote, index) in lotes"
                    :key="lote"
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="vincularAoLote(documento, lote)"
                    style="margin-right: 5px"
                  >
                    Lote {{ lote.lote_numero }}
                    <i class="fas fa-link"></i>
                  </a>
                  -->
                </td>
                <td style="text-align: center">
                  <button
                    style="background-color: #d43f3a; border-color: #d43f3a"
                    @click="confirmarDelete(documento)"
                    type="button"
                    class="btn btn-danger btn-sm"
                  >
                    Deletar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["leilao", "lotes"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      documento_selecionado: "",
      filtro: "",
      paginas: [],
      documentos: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome: "",
      estado: "",
      cidade: "",
      cidades: "",
      cpf_cnpj: "",
      endereco: "",
      email: "",
      fone: "",
      nome_contato: "",
      arquivos_leilao: "",
      arquivos_lote: "",
      lote_selecionado: "",
    };
  },

  mounted() {
    console.log(this.documentos);
    this.buscarDocumentos();
  },

  methods: {
    confirmarDelete(value) {
      let html = "Esta ação é irreversível. Deseja continuar? ";

      this.$swal
        .fire({
          title: "Atenção",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.deletarDocumento(value);
          }
        });
    },

    deletarDocumento(documento) {
      this.isLoading = true;

      let data = {
        id: documento.id,
      };

      console.log("DELETANDO DOC");
      console.log(data);

      axios
        .post(`/admin/documento/delete`, data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessage("Documento deletado!");

            let data = {
              path: this.getOnlyDocumentPath(documento),
            };

            console.log("DELETANDO S3");
            console.log(data);

            axios
              .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/delete-file`, data)
              .then((response) => {})
              .catch((error) => {
                console.log(error);
                this.isLoading = false;
                this.showErrorMessageWithButton("Ops..", error);
              });
            this.buscarDocumentos();
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
            this.buscarDocumentos();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Falha ao deletar documento!");
          this.isLoading = false;
        });
    },

    getOnlyDocumentPath(document) {
      console.log("Doc");
      console.log(document);

      if (document) {
        if (document.path.includes("rochaleiloes3")) {
          return document.path + "/" + document.file;
        } else if (document.path.includes("rochaleiloes2")) {
          return document.path + "/" + document.file;
        } else if (document.path.includes("rochaleiloes")) {
          return document.path + "/" + document.file;
        } else {
          return document.path + "/" + document.file;
        }
      }
    },

    downloadWithAxios(documento) {
      if (documento) {
        let url = process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + documento.path + "/" + documento.file;
        let title = documento.nome + "." + documento.ext;

        axios({
          method: "get",
          url,
          responseType: "arraybuffer",
        })
          .then((response) => {
            this.forceFileDownload(response, title, documento.ext);
          })
          .catch(() => console.log("error occured"));
      }
    },

    forceFileDownload(response, title, type) {
      console.log("Baixando agora");
      console.log(type);
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: type }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },

    editarOrdem(documento) {
      console.log("Editando documento " + documento);
      documento.edit_ordem = false;

      let data = {
        documento_id: documento.id,
        ordem: documento.ordem,
      };

      axios
        .post(`/admin/documento/update_ordem`, data)
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage("Ordem atualizada");
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    upperDocumento() {
      this.documento.nome = this.documento.nome.toUpperCase();
    },

    getTextoVinculado(lotes) {
      let texto = "";

      if (lotes) {
        for (let i = 0; i < lotes.length; i++) {
          if (i > 0) {
            texto = texto + ", ";
          }

          texto = texto + lotes[i].lote_numero;
        }

        return texto;
      } else {
        return texto;
      }
    },

    getLotesDoLeilao(lotes_documento) {
      if (lotes_documento) {
        let array_lotes_do_leilao_vinculados = [];

        for (let i = 0; i < lotes_documento.length; i++) {
          let indice = this.findLote(this.lotes, lotes_documento[i].id);

          if (indice >= 0 && lotes_documento[i].leilao_id == this.leilao.id) {
            array_lotes_do_leilao_vinculados.push(this.lotes[indice]);
          }
        }

        return array_lotes_do_leilao_vinculados;
      } else {
        return [];
      }
    },

    getArrayLotes(lotes_documento) {
      if (lotes_documento) {
        let array_lotes_sem_vinculados = [];

        for (let i = 0; i < this.lotes.length; i++) {
          let indice = this.findLote(lotes_documento, this.lotes[i].id);

          if (indice < 0) {
            array_lotes_sem_vinculados.push(this.lotes[i]);
          }
        }

        return array_lotes_sem_vinculados;
      } else {
        return [];
      }
    },

    findLote(array, id) {
      let indice = array.findIndex((element) => element["id"] == id);

      return indice;
    },

    findLeilao(array, id) {
      let indice = array.findIndex((element) => element["id"] == id);

      return indice;
    },

    desvincularAoLeilao(documento) {
      this.isLoading = true;

      let data = {
        documento_id: documento.id,
        leilao_id: this.leilao.id,
      };

      console.log(data);

      axios
        .post(`/admin/documento/desvincular_leilao`, data)
        .then((response) => {
          this.showSuccessMessage("Leilão desvinculado");
          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    vincularAoLeilao(documento) {
      this.isLoading = true;

      let data = {
        documento_id: documento.id,
        leilao_id: this.leilao.id,
      };

      console.log(data);

      axios
        .post(`/admin/documento/vincular_leilao`, data)
        .then((response) => {
          this.showSuccessMessage("Leilão vinculado");
          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    atualizarDocumentoEdital(documento) {
      this.isLoading = true;
      let edital = 0;

      if (documento.is_edital) {
        edital = 1;
      }

      let data = {
        leilao_id: this.leilao.id,
        documento_id: documento.id,
        edital: edital,
      };

      console.log(data);

      axios
        .post(`/admin/documento/atualizar_edital`, data)
        .then((response) => {
          this.showSuccessMessage("Lote desvinculado");
          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    atualizarVinculoLeilao(documento) {
      /*
      if (documento.model_id == this.leilao.id) {
        this.desvincularAoLeilao(documento);
      } else {
        this.vincularAoLeilao(documento);
      }*/

      let indice = this.findLeilao(documento.leiloes, this.leilao.id);

      if (indice >= 0) {
        this.desvincularAoLeilao(documento);
      } else {
        this.vincularAoLeilao(documento);
      }
    },

    desvincularAoLote(documento, lote) {
      let data = {
        documento_id: documento.id,
        lote_id: lote.id,
      };

      console.log(data);

      axios
        .post(`/admin/documento/desvincular_lote`, data)
        .then((response) => {
          this.showSuccessMessage("Lote desvinculado");
          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    vincularAoLote(documento) {
      if (documento.lote_selecionado) {
        let data = {
          documento_id: documento.id,
          lote_id: documento.lote_selecionado.id,
        };

        console.log(data);

        axios
          .post(`/admin/documento/vincular_lote`, data)
          .then((response) => {
            this.showSuccessMessage("Lote vinculado");
            window.location.reload();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },

    isVinculado(documento) {
      /*
      if (documento.model_id == this.leilao.id) {
        return "Sim";
      } else {
        return "Não";
      }*/

      let indice = this.findLeilao(documento.leiloes, this.leilao.id);

      if (indice >= 0) {
        return "Sim";
      } else {
        return "Não";
      }
    },

    editarNome(documento) {
      console.log("Editando documento");
      documento.edit = false;

      let data = {
        id: documento.id,
        nome: documento.nome.toUpperCase(),
      };

      axios
        .post(`/admin/documento/update_nome`, data)
        .then((response) => {
          this.showSuccessMessage("Nome atualizado");
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    sendFileS3(file, action) {
      if (this.arquivos_lote && this.arquivos_lote != "") {
        this.isLoading = true;

        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("id", "1");
          formData.append("path", "rochaleiloes2/documentos/leilao/" + this.leilao.id + "/");

          for (let i = 0; i < this.arquivos_lote.length; i++) {
            formData.append("files", this.arquivos_lote[i]);
          }

          axios
            .post(process.env.MIX_VUE_APP_UPLOAD_URL + `/s3/upload-multiple`, formData)
            .then((response) => {
              console.log(response.data);
              console.log("ENVIANDO PARA O BANCO\n");

              this.storeDB(response.data.files);
            })
            .catch((error) => {
              console.log(error);
              this.isLoading = false;
              this.showErrorMessageWithButton("Ops..", error.response.data.error);
              reject();
            });
        });
      } else {
        this.showErrorMessageWithButton("Ops...", "Envio um arquivo válido");
      }
    },

    storeDB(files, action) {
      let arr_arquivos = [];

      for (let i = 0; i < files.length; i++) {
        //DEFININDO ARQUIVO
        let fileName = files[i].file.split("/");
        let ext = files[i].file.split(".");

        console.log("A"+i );
        console.log(files[i]);

        let file = {
          file: fileName[fileName.length - 1],
          ext: ext[ext.length - 1],
          originalName: files[i].originalName
        };

        console.log("File");
        console.log(file);
        arr_arquivos.push(file);
      }

      let data = {
        path: "rochaleiloes2/documentos/leilao/" + this.leilao.id,
        leilao_id: this.leilao.id,
        files: arr_arquivos,
      };

      console.log("Enviando agora");
      console.log(data);

      axios
        .post("/admin/documento/store_lote", data)
        .then((response) => {
          this.isLoading = false;
          this.showSuccessMessage("Documento(s) enviado(s)!");

          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
        });
    },

    async uploadLote() {
      if (this.arquivos_lote && this.arquivos_lote != "") {
        this.isLoading = true;

        console.log(this.arquivos_lote);

        let fd = new FormData();

        for (let i = 0; i < this.arquivos_lote.length; i++) {
          fd.append("files[]", this.arquivos_lote[i]);
        }

        fd.append("leilao_id", this.leilao.id);

        console.log("Cadastrando");
        console.log(fd);

        axios
          .post(`/admin/documento/store_lote`, fd)
          .then((response) => {
            this.isLoading = false;

            this.showSuccessMessage("Documento cadastrado!");

            window.location.reload();
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      } else {
        this.showErrorMessageWithButton("Ops...", "Envio um arquivo válido");
      }
    },

    async uploadLeilao() {
      if (this.arquivos_leilao) {
        this.isLoading = true;

        console.log(this.arquivos_leilao);

        let fd = new FormData();

        for (let i = 0; i < this.arquivos_leilao.length; i++) {
          fd.append("files[]", this.arquivos_leilao[i]);
        }

        fd.append("leilao_id", this.leilao.id);

        console.log("Cadastrando");
        console.log(fd);

        axios
          .post(`/admin/documento/store_leilao`, fd)
          .then((response) => {
            this.isLoading = false;

            this.showSuccessMessage("Documento cadastrado!");

            window.location.reload();
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      } else {
        this.showErrorMessageWithButton("Ops...", "Envio um arquivo válido");
      }
    },

    onChangeLote(e) {
      //this.arquivo_lote = e.target.files[0];

      this.arquivos_lote = [];

      for (let i = 0; i < e.target.files.length; i++) {
        this.arquivos_lote.push(e.target.files[i]);
      }
    },

    onChangeLeilao(e) {
      //this.arquivo_leilao = e.target.files[0];

      this.arquivos_leilao = [];

      for (let i = 0; i < e.target.files.length; i++) {
        this.arquivos_leilao.push(e.target.files[i]);
      }
    },

    getImagePath(documento) {
      //return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + documento.path + "/" + documento.file;

      if (documento.path && documento.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + documento.path + "/" + documento.file;
      } else if (documento.path && documento.path.includes("rochaleiloes")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + documento.path + "/" + documento.file;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + documento.path + "/" + documento.file;
      }
    },

    getUrlEdit(documento) {
      return "/admin/documento/" + documento.id;
    },

    show(documento) {
      this.documento_selecionado = documento;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarDocumentos();
      }
    },

    buscarDocumentos() {
      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      axios
        .post(`/admin/documentos/search`, data)
        .then((response) => {
          this.isLoading = false;

          let docs = response.data.documentos;

          docs.sort((a, b) => a.ordem - b.ordem);

          this.documentos = docs;

          //this.documentos = response.data.documentos;

          this.total = response.data.total;

          console.log(this.documentos);

          for (let i = 0; i < this.documentos.length; i++) {
            this.documentos[i].vinculado_leilao = this.isVinculado(this.documentos[i]);
            this.documentos[i].is_edital = this.documentos[i].edital == 1;
          }

          //this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarDocumentos();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style>
input[type="text"]:disabled {
  background: white;
  border: none;
}

input[type="text"] {
  border-color: black;
}
</style>
